import { render, staticRenderFns } from "./widgets-descriptions.html?vue&type=template&id=26807c0c&scoped=true&"
import script from "./widgets-descriptions.js?vue&type=script&lang=js&"
export * from "./widgets-descriptions.js?vue&type=script&lang=js&"
import style0 from "./widgets-descriptions.scss?vue&type=style&index=0&id=26807c0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26807c0c",
  null
  
)

export default component.exports